import { api } from './client'

export interface Tariff {
  id: string
  name: string
  amountPerMin: number
  hourlyPriceUzs: number | null
  startAt: string | null
  endAt: string | null
  currency: 'UZS'
}

export interface Zone {
  id: string
  code: string
  externalId: string | null
  title: string | null
  name: string
  address: string | null
  city: string
  centroidLat: number
  centroidLng: number
  capacity: number
  territoryCoordinates: number[][][] | null
  tariff: Tariff | null
}

export async function fetchZones(): Promise<Zone[]> {
  const res = await api<{ zones: Zone[]; total: number }>('/zones/')
  return res.zones
}
